<template>
    <main class="">
        <EditAnnouncement ref="editAnnouncement"
                          :announcement-data="announcementData"
                          title="Δημιουργία ανακοίνωσης"
                          @save:success="successSave"
        />

        <br>

        <div class="container">
                <div class="row justify-content-center">
                    <button class="col-md-2 btn btn-primary" type="button"
                            v-on:click="createAnnouncement">{{submit_button_text}}
                    </button>
                </div>
        </div>
    </main>
</template>

<script>
import EditAnnouncement from '../../components/EditAnnouncement'
import {Structs as structs} from "@/structs";

export default {
    name: "CreateAnnouncement",
    components: {
        EditAnnouncement
    },
    computed: {
        role: function () {
            return this.$store.getters.userRole;
        },
        submit_button_text : function() {
            return this.$store.getters.userRole === "ROLE_ADMIN" ? 'Δημοσίευση' : 'Αποστολή για έγκριση';
        }
    },
    data: function () {
        return {
            announcementData: structs.AnnouncementData()
        };
    },
    created() {
        if (!this.$store.getters.getToken) this.$router.push({name: 'login'});

        if (this.$store.getters.userRole === "ROLE_USER") this.$router.push('login');
    },
    methods: {
        createAnnouncement() {
            this.$refs.editAnnouncement.save();
        },
        successSave: function(id) {
            this.$router.push(`view_me_announcement/${id}`)
        },
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>